import React, { useState } from "react";
import Hero_2 from "../../components/Hero_2/Hero_2";
import Loading from "../../components/Loading/Loading";
import OfferBanner from "../../components/OfferBanner/OfferBanner";
import Services from "../Services/Services";
import Footer2 from "../../components/Footer_2/Footer_2";

const Home1 = () => {
  const [loading, setLoading] = useState(false);
  setTimeout(() => {
    setLoading(true);
  }, 2100);

  return (
    <div>
      {loading == true ? (
        <>
          <Hero_2 />
          <OfferBanner />
          <Services />
          {/* footer component */}

          <Footer2 />
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Home1;
